var map = {
	"./Pat and.jpg": 314,
	"./WhatsApp Image 2022-10-18 at 11.53.29 AM.jpeg": 315,
	"./WhatsApp Image 2022-10-18 at 12.39.28 PM (1).jpeg": 316,
	"./WhatsApp Image 2022-10-19 at 3.06.58 PM.jpeg": 317,
	"./WhatsApp Image 2023-09-14 at 16.46.54_c20fbcc5.jpg": 318,
	"./WhatsApp Image 2023-09-14 at 18.41.49_2138c53b.jpg": 319,
	"./WhatsApp Image 2023-10-18 at 21.39.12_bbe8cd12.jpg": 320,
	"./kfc-24-50.jpg": 321,
	"./kfc-24-62.jpg": 322,
	"./kfc-24-67.jpg": 323,
	"./kfc-24-81.jpg": 324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 313;